import produce from "immer";
import { IStoreState } from "../initialStoreState";
import { LoadState } from "../../constants/enums";
import { defaultCourseandBatchReport, defaultCourseandBatchReportState } from "./default";
import { CLEAR_COURSE_REPORT, CLEAR_COURSE_REPORT_STATE, FETCH_COURSE_REPORT_LIST_FAILED, FETCH_COURSE_REPORT_LIST_PROGRESS, FETCH_COURSE_REPORT_LIST_SUCCESS } from "./cbActions";
import { CourseAndBatchReportActions } from ".";

export const courseandbatchReportReducer = (
  state: IStoreState["courseandbatch"] = defaultCourseandBatchReportState,
  action: CourseAndBatchReportActions
) => {
    switch (action.type) {
        case FETCH_COURSE_REPORT_LIST_PROGRESS: {
             const newState = produce(state, (draftState) => {
               draftState.courseandbatch.loading = LoadState.InProgress;
               draftState.list.data = [];
               draftState.courseandbatch.data = defaultCourseandBatchReport;
               draftState.list.totalRecords = 0;
             });
             return newState;
           }
           case FETCH_COURSE_REPORT_LIST_SUCCESS: {
             const { data,  singleReport, totalRecords, totalFee, feesPaid, pendingFee } = action.payload;
             const newState = produce(state, (draftState) => {
               draftState.courseandbatch.loading = LoadState.Loaded;
               draftState.courseandbatch.data = singleReport;
               draftState.list.data = data;
                draftState.amount.totalFee = totalFee;
                draftState.amount.feesPaid = feesPaid;
                draftState.amount.pendingFee = pendingFee;
               draftState.list.totalRecords = totalRecords;

             });
             return newState;
           }
           case FETCH_COURSE_REPORT_LIST_FAILED: {
             const newState = produce(state, (draftState) => {
               draftState.courseandbatch.loading = LoadState.Failed;
               draftState.list.data = [];
               draftState.courseandbatch.data = defaultCourseandBatchReport;
               draftState.list.totalRecords = 0;


             });
             return newState;
           }
           case CLEAR_COURSE_REPORT_STATE: {
            return defaultCourseandBatchReportState;
           }
           case CLEAR_COURSE_REPORT: {
            return defaultCourseandBatchReportState;
           }
           default: {
            return state;
          }
      }
    
};